import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { EntryPage } from './pages/EntryPage';
import { QueuesPage } from './pages/QueuesPage';
import { QueuePage } from './pages/QueuePage';
import { IssuesPage } from './pages/IssuesPage';
import { IssuePage } from './pages/IssuePage';
import { BoardsPage } from './pages/BoardsPage';
import { BoardPage } from './pages/BoardPage';
import { SettingsPage } from './pages/SettingsPage';

export const router = createBrowserRouter([
  { path: '/', element: <EntryPage /> },
  {
    path: '/t/:tenantId',
    element: <AppLayout />,
    children: [
      // Очереди — первый экран: в трекере задача живёт в очереди, и начинается всё с неё.
      { index: true, element: <Navigate to="queues" replace /> },
      { path: 'queues', element: <QueuesPage /> },
      { path: 'queues/:queueId', element: <QueuePage /> },
      { path: 'issues', element: <IssuesPage /> },
      { path: 'issues/:issueKey', element: <IssuePage /> },
      { path: 'boards', element: <BoardsPage /> },
      { path: 'boards/:boardId', element: <BoardPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);